import api from '@/apis'

export default {
  state: {
    visibility: false,
    page_loading: false,
    table: {
      items: [],
      options: { page: 1, itemsPerPage: 10 },
      headers: [
        { title: '', value: 'create_datetime', width: 118 },
        { title: 'Device', value: 'real_session_id' },
        { title: 'Status', value: 'status', width: 92 }
      ],
      total_items: 0,
      loading: false,
      date: [],
      time: { from: '', to: '' },
      search: '',
      status: ['answered', 'ended']
    }
  },
  mutations: {
    INIT_LIVE_VIDEO_CALL_HISTORY_DIALOG(state) {
      state.visibility = true
    },
    RESET_LIVE_VIDEO_CALL_HISTORY_DIALOG(state) {
      state.visibility = false
      state.table.search = ''
    },
    SET_DATA_LIVE_VIDEO_CALL_HISTORY_DIALOG(state, payload) {
      state.table.items = payload
    },
    SET_LIVE_VIDEO_CALL_TABLE_LOADING(state, payload) {
      state.table.loading = payload
    },
    SET_LIVE_VIDEO_CALL_TABLE_OPTIONS(state, payload) {
      state.table.options = payload
    },
    SET_LIVE_VIDEO_CALL_TABLE_OPTIONS_PAGE(state, payload) {
      state.table.options.page = payload
    },
    SET_LIVE_VIDEO_CALL_TABLE_TOTAL_ITEMS(state, payload) {
      state.table.total_items = payload
    },
    SET_LIVE_VIDEO_CALL_TABLE_DATE(state, payload) {
      state.table.date = payload
    },
    SET_LIVE_VIDEO_CALL_TABLE_TIME(state, payload) {
      state.table.time = payload
    },
    SET_LIVE_VIDEO_CALL_TABLE_SEARCH(state, payload) {
      state.table.search = payload
    }
  },
  actions: {
    async fetchLiveVideoCallList({ rootState, commit, state }, payload) {
      try {
        commit('SET_DATA_LIVE_VIDEO_CALL_HISTORY_DIALOG', [])
        commit('SET_LIVE_VIDEO_CALL_TABLE_TOTAL_ITEMS', 0)

        const device_id = rootState.auth.selected_device
        const table = state.table

        const page = state.table.options.page
        const itemsPerPage = state.table.options.itemsPerPage
        commit('SET_LIVE_VIDEO_CALL_TABLE_LOADING', true)
        const response = await api.getLiveVideoCallHistory({
          device_id: device_id,
          params: {
            ...payload.params,
            status: table.status,
            search: table.search || null,
            limit: itemsPerPage,
            offset: page * itemsPerPage - itemsPerPage
          }
        })
        if (response.data.success) {
          commit('SET_LIVE_VIDEO_CALL_TABLE_LOADING', false)
          commit('SET_DATA_LIVE_VIDEO_CALL_HISTORY_DIALOG', response.data.data)
          commit('SET_LIVE_VIDEO_CALL_TABLE_TOTAL_ITEMS', response.data.total)
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      }
    }
  }
}
